import {
  Armchair,
  ArrowLeftRight,
  Award,
  Banknote,
  BarChart3,
  BookMarked,
  BookOpen,

  BookOpenCheck,
  Boxes,
  Briefcase,
  Building2,
  Bus,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  Contact,
  CreditCard,
  FileBarChart,
  FileCheck2,
  FileSpreadsheet,
  FileText,
  LayoutDashboard,
  LayoutGrid,
  LibraryBig,
  MapPin,
  MessageSquare,
  Percent,
  Receipt,
  School,
  ScrollText,
  Settings,
  ShieldCheck,
  Tags,
  UserCheck,
  UserCog,
  UserPlus,
  Users,
  UsersRound,
} from 'lucide-react'

export interface NavigationItem {
  label: string
  path: string
  permission: string
  icon: any
  exact?: boolean
  children?: NavigationItem[]
}

export interface NavigationSection {
  title: string
  items: NavigationItem[]
}

export const navigationConfig: NavigationSection[] = [
  {
    title: 'Main',
    items: [
      {
        label: 'Dashboard',
        path: '/dashboard',
        permission: 'dashboard:view',
        icon: LayoutDashboard,
      },
    ],
  },
  {
    title: 'Front Office',
    items: [
      {
        label: 'Admission Enquiries',
        path: '/admin/frontoffice/admission-enquiries',
        permission: 'dashboard:view',
        icon: Contact,
      },
      {
        label: 'Admission Application',
        path: '/admin/admission-application',
        permission: 'admission-application:view',
        icon: ClipboardList,
      },
      {
        label: 'Admission Process',
        path: '/admin/admission-process',
        permission: 'admission-process:view',
        icon: UserCheck,
      },
      {
        label: 'Seat Management',
        path: '/seat-planning',
        permission: 'dashboard:view',
        icon: Armchair,
      },
    ],
  },
  {
    title: 'Visitor Management',
    items: [
      {
        label: 'Visitor Dashboard',
        path: '/admin/frontoffice/visitor-management',
        permission: 'dashboard:view',
        icon: LayoutDashboard,
        exact: true,
      },
      {
        label: 'Visitor Entry',
        path: '/admin/frontoffice/visitor-management/new',
        permission: 'dashboard:view',
        icon: UserCheck,
      },
      {
        label: 'Visitor Log',
        path: '/admin/frontoffice/visitor-management/log',
        permission: 'dashboard:view',
        icon: ScrollText,
      },
    ],
  },
  {
    title: 'Student Management',
    items: [
      {
        label: 'Student Directory',
        path: '/admin/student-directory',
        permission: 'student-directory:view',
        icon: Users,
      },
      {
        label: 'Student Lifecycle',
        path: '/admin/student-lifecycle',
        permission: 'student-directory:view',
        icon: UserCheck,
      },
      {
        label: 'Student Doc Verification',
        path: '/admin/document-verification',
        permission: 'document-verification:view',
        icon: FileCheck2,
      },
      {
        label: 'Attendance',
        path: '/teacher/attendence',
        permission: 'attendance:view',
        icon: CalendarDays,
      },
      {
        label: 'Student Reports',
        path: '/admin/student-reports',
        permission: 'dashboard:view',
        icon: BarChart3,
      },
    ],
  },
  {
    title: 'LIBRARY MANAGEMENT',
    items: [
      {
        label: 'Library Home',
        path: '/teacher-library',
        permission: 'library:view',
        icon: LibraryBig,
      },
      {
        label: 'Browse Books',
        path: '/teacher-library/browse-books',
        permission: 'library:view',
        icon: BookOpen,
      },
      {
        label: 'My Books',
        path: '/teacher-library/my-books',
        permission: 'library:view',
        icon: BookMarked,
      },
    ],
  },
  {
    title: 'Library Management',
    items: [
      {
        label: 'Library Dashboard',
        path: '/admin-library/dashboard',
        permission: 'library:view',
        icon: LibraryBig,
      },
      {
        label: 'Library Catalogue',
        path: '/admin-library/catalogue',
        permission: 'library:view',
        icon: BookOpen,
      },
      {
        label: 'Inventory Management',
        path: '/admin-library/inventory',
        permission: 'library:view',
        icon: Boxes,
      },
      {
        label: 'Issue / Return',
        path: '/admin-library/issue-return',
        permission: 'library:view',
        icon: ArrowLeftRight,
      },
      {
        label: 'Fine Management',
        path: '/admin-library/fine-management',
        permission: 'library:view',
        icon: Receipt,
      },
      {
        label: 'Reports',
        path: '/admin-library/reports',
        permission: 'library:view',
        icon: BarChart3,
      },
    ],
  },
  {
    title: 'Academic Management',
    items: [
      {
        label: 'Academics',
        path: '/admin/academics',
        permission: 'academics:view',
        icon: School,
        exact: true,
      },
      {
        label: 'Calendar',
        path: '/admin/events-calendar',
        permission: 'academics:view',
        icon: CalendarDays,
      },
      {
        label: 'Subject Management',
        path: '/admin/academics/subject-management',
        permission: 'subjects:view',
        icon: BookOpen,
      },
      {
        label: 'Subject Allocation',
        path: '/admin/class-management/subject-allocation',
        permission: 'subjects:view',
        icon: BookOpen,
      },
      {
        label: 'Timetable',
        path: '/academics/timetable',
        permission: 'timetable:view',
        icon: CalendarRange,
      },
      {
        label: 'Assignments',
        path: '/teacher/assignments',
        permission: 'assignments:view',
        icon: FileText,
      },
      {
        label: 'Homework',
        path: '/teacher/homework',
        permission: 'assignments:view',
        icon: BookOpenCheck,
      },
      {
        label: 'Lesson Plans',
        path: '/teacher/lessonplans',
        permission: 'lesson-plans:view',
        icon: ScrollText,
      },
    ],
  },
  {
    title: 'HRMS',
    items: [
      {
        label: 'Dashboard',
        path: '/admin/hrms/dashboard',
        permission: 'dashboard:view',
        icon: LayoutDashboard,
      },
      {
        label: 'Onboarding',
        path: '/admin/hrms/onboarding',
        permission: 'dashboard:view',
        icon: UserPlus,
      },
      {
        label: 'Staff Directory',
        path: '/admin/hrms/new-staff-directory',
        permission: 'staff-directory:view',
        icon: Briefcase,
      },
      {
        label: 'Staff Documents',
        path: '/admin/hrms/staff-documents',
        permission: 'dashboard:view',
        icon: FileCheck2,
      },
      {
        label: 'Attendance & Leave',
        path: '/admin/hrms/attendance-leave',
        permission: 'dashboard:view',
        icon: UserCheck,
      },
      {
        label: 'Staff Attendance',
        path: '/teacher/attendance',
        permission: 'dashboard:view',
        icon: UserCheck,
      },
      {
        label: 'Payroll',
        path: '/admin/hrms/payroll',
        permission: 'dashboard:view',
        icon: Banknote,
      },
      {
        label: 'Employee Reports',
        path: '/admin/hrms/employee-reports',
        permission: 'dashboard:view',
        icon: FileBarChart,
      },
    ],
  },

  {
    title: 'Examination',
    items: [
      {
        label: 'Examination',
        path: '/admin/academic/examinations',
        permission: 'academics:view',
        icon: ClipboardCheck,
        children: [
          {
            label: 'Exam Configuration',
            path: '/admin/academic/examinations/exam-configuration',
            permission: 'academics:view',
            icon: Settings,
          },
          {
            label: 'Exam Schedule',
            path: '/admin/academic/examinations/exam-schedule',
            permission: 'academics:view',
            icon: CalendarDays,
          },
          {
            label: 'Marks Entry',
            path: '/admin/academic/examinations/marks-entry',
            permission: 'academics:view',
            icon: FileSpreadsheet,
          },
          {
            label: 'Report Card',
            path: '/admin/academic/examinations/report-card',
            permission: 'academics:view',
            icon: Award,
          },
          {
            label: 'Performance Reports',
            path: '/admin/academic/examinations/performance',
            permission: 'academics:view',
            icon: BarChart3,
          },
        ],
      },
      {
        label: 'Exam Management',
        path: '/teacher/exam-management',
        permission: 'assignments:view',
        icon: ClipboardCheck,
      },
    ],
  },
  {
    title: 'Class Management',
    items: [
      {
        label: 'Class & Section Setup',
        path: '/admin/enrollment/class-section-setup',
        permission: 'seat-management:view',
        icon: LayoutGrid,
      },
      {
        label: 'My Classes',
        path: '/teacher/myclasses',
        permission: 'class-management:view',
        icon: ClipboardCheck,
      },
      {
        label: 'Classes',
        path: '/admin/class-management/classes',
        permission: 'class-management:view',
        icon: ClipboardCheck,
      },
      {
        label: 'Class Reports',
        path: '/admin/class-management/class-reports',
        permission: 'class-management:view',
        icon: BarChart3,
      },
    ],
  },
  {
    title: 'Finance Management',
    items: [
      {
        label: 'Overview',
        path: '/admin/finance/fees-finance/overview',
        permission: 'finance:view',
        icon: LayoutDashboard,
      },
      {
        label: 'Fee Head',
        path: '/admin/finance/fees-finance/fee-head',
        permission: 'finance:view',
        icon: Tags,
      },
      {
        label: 'Fee Structure',
        path: '/admin/finance/fees-finance/fee-structure',
        permission: 'finance:view',
        icon: FileSpreadsheet,
      },
      {
        label: 'Fee Collection',
        path: '/admin/finance/fees-finance/payments',
        permission: 'finance:view',
        icon: CreditCard,
      },
      {
        label: 'Discounts',
        path: '/admin/finance/fees-finance/discounts',
        permission: 'finance:view',
        icon: Percent,
      },
      {
        label: 'Fee Reports',
        path: '/admin/finance/fees-finance/reports',
        permission: 'finance:view',
        icon: BarChart3,
      },
      {
        label: 'Approvals',
        path: '/admin/finance/fees-finance/approvals',
        permission: 'finance:view',
        icon: ClipboardCheck,
      },
    ],
  },
  {
    title: 'Communication',
    items: [
      {
        label: 'Communication Dashboard',
        path: '/communication',
        permission: 'communication:view',
        icon: MessageSquare,
        exact: true,
      },
      {
        label: 'Message',
        path: '/communication/message',
        permission: 'communication:view',
        icon: MessageSquare,
      },
      {
        label: 'Notices',
        path: '/communication/notices',
        permission: 'communication:view',
        icon: ClipboardList,
      },
      {
        label: 'Groups',
        path: '/communication/groups',
        permission: 'communication:view',
        icon: UsersRound,
      },
    ],
  },
  {
    title: 'Transport Management',
    items: [
      {
        label: 'Route & Stop Management',
        path: '/admin/transport/routes',
        permission: 'transport:view',
        icon: MapPin,
      },
      {
        label: 'Vehicle Management',
        path: '/admin/transport/vehicles',
        permission: 'transport:view',
        icon: Bus,
      },
      {
        label: 'Driver & Attendant Management',
        path: '/admin/transport/driver-attendants',
        permission: 'transport:view',
        icon: Users,
      },
      {
        label: 'Student Transport Allocation',
        path: '/admin/transport/student-allocation',
        permission: 'transport:view',
        icon: Users,
      },
      {
        label: 'Transport Fee',
        path: '/admin/transport/fee-bands',
        permission: 'transport:view',
        icon: CreditCard,
      },
      {
        label: 'Transport Reports & Alerts',
        path: '/admin/transport/reports',
        permission: 'transport:view',
        icon: FileText,
      },
    ],
  },

  {
    title: 'User & Role Management',
    items: [
      {
        label: 'User Management',
        path: '/admin/user-management',
        permission: 'user-management:view',
        icon: UserCog,
      },
      {
        label: 'Role Management',
        path: '/admin/user-management/role-management',
        permission: 'role-management:view',
        icon: ShieldCheck,
      },
      {
        label: 'Departments',
        path: '/admin/user-management/departments',
        permission: 'departments:view',
        icon: Building2,
      },
      {
        label: 'Designations',
        path: '/admin/user-management/designations',
        permission: 'designations:view',
        icon: Briefcase,
      },
      {
        label: 'Audit Logs',
        path: '/admin/audit-logs',
        permission: 'audit-logs:view',
        icon: ScrollText,
      },
    ],
  },
]
